import type { ComponentProps } from 'react';
import { UserButton } from '@clerk/clerk-react';
import { Languages } from 'lucide-react';
import { useLanguage } from '@/shared/contexts/LanguageContext';
import { useTranslation } from 'react-i18next';
import { SupportedLanguages } from '@/i18n/i18next';
import { LanguageSelector } from './LanguageSelector';

const languageLabels: Record<SupportedLanguages, string> = {
  en: 'English',
  he: 'עברית',
};

const languageFlags: Record<SupportedLanguages, string> = {
  en: '🇺🇸',
  he: '🇮🇱',
};

type UserButtonAppearance = ComponentProps<typeof UserButton>['appearance'];

type UserSettingsProps = {
  appearance?: UserButtonAppearance;
};

export const UserSettings = ({ appearance }: UserSettingsProps) => {
  const { language } = useLanguage();
  const { t } = useTranslation('common');

  const currentLanguageLabel = languageLabels[language];
  const currentLanguageFlag = languageFlags[language];

  return (
    <UserButton appearance={appearance}>
      <UserButton.MenuItems>
        <UserButton.Action
          label={`${t(
            'language'
          )}:\u00A0\u00A0\u00A0${currentLanguageFlag} ${currentLanguageLabel}`}
          labelIcon={<Languages className="h-4 w-4" />}
          open="language"
        />
      </UserButton.MenuItems>
      <UserButton.UserProfilePage
        label={t('language')}
        labelIcon={<Languages className="h-4 w-4" />}
        url="language"
      >
        <div className="space-y-4 p-6">
          <div className="space-y-1">
            <h2 className="text-xl font-semibold">{t('language')}</h2>
            <p className="text-sm text-muted-foreground">
              {t('selectYourPreferredLanguage')}
            </p>
          </div>
          <LanguageSelector />
        </div>
      </UserButton.UserProfilePage>
    </UserButton>
  );
};
